var map = {
	"./CallForProposals.js": 3522,
	"./Collection.js": 7867,
	"./GatheringPublicOpinion.js": 5651,
	"./Universal.js": 4056,
	"./committeeWorkstation.js": 5277,
	"./internetPolitics.js": 711,
	"./livingRoom.js": 4365,
	"./remoteNegotiation.js": 7394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5982;